import { Component } from '@angular/core';
import { ClienteRelatorio, RelatorioDinamicoService } from 'src/app/services/relatorio-dinamico.service';
import { formatarDocumento } from '../busca-clientes/busca-clientes.component';

@Component({
  selector: 'habil-seletor-base',
  templateUrl: './seletor-base.component.html',
  styleUrls: ['./seletor-base.component.scss'],
})
export class SeletorBaseComponent {
  mostrar = false;
  cnpj = '';
  host = '';
  testando = false;
  teste: any = null;
  erro = '';
  empresasEscolhidas: number[] = [];
  cliente: ClienteRelatorio = null;
  sugestoes: ClienteRelatorio[] = [];
  formatar = formatarDocumento;

  constructor(public service: RelatorioDinamicoService) {}

  get rotulo(): string {
    return this.service.base?.descricao || 'Escolher base da prévia';
  }

  abrir(): void {
    this.cnpj = this.service.base?.cnpj || '';
    this.host = this.service.base?.host || '';
    this.empresasEscolhidas = [...(this.service.base?.empresas || [])];
    this.teste = null;
    this.erro = '';
    this.cliente = null;
    this.mostrar = true;
    if (this.cnpj) {
      this.identificar();
      this.testar();
    }
  }

  buscar(texto: string): void {
    this.service.buscarClientes(texto).subscribe(
      (lista) => {
        this.erro = '';
        this.sugestoes = lista;
      },
      (e) => {
        this.sugestoes = [];
        this.erro = 'Não foi possível buscar os clientes: ' + this.service.mensagemErro(e);
      }
    );
  }

  digitar(valor: any): void {
    if (typeof valor === 'string') {
      this.cnpj = valor;
      this.cliente = null;
      this.teste = null;
    }
  }

  escolher(c: ClienteRelatorio): void {
    this.cliente = c;
    this.cnpj = c.cnpj;
    this.host = '';
    this.testar();
  }

  testar(): void {
    if (this.testando) {
      return;
    }
    if (!this.cnpj.trim()) {
      this.erro = 'Informe o cliente.';
      return;
    }
    this.testando = true;
    this.erro = '';
    this.teste = null;
    if (!this.cliente) {
      this.identificar();
    }
    this.service.testarBase({ cnpj: this.cnpj.trim(), host: this.host.trim() || null }).subscribe(
      (r) => {
        this.testando = false;
        this.teste = r;
        const ids = new Set((r.empresas || []).map((e: any) => e.id));
        this.empresasEscolhidas = this.empresasEscolhidas.filter((id) => ids.has(id));
      },
      (e) => {
        this.testando = false;
        this.erro = this.service.mensagemErro(e);
      }
    );
  }

  usar(): void {
    const qtde = this.empresasEscolhidas.length;
    const nome = this.cliente?.nome ? this.cliente.nome + ' · ' : '';
    this.service.definirBase({
      cnpj: this.cnpj.trim(),
      host: this.host.trim() || null,
      empresas: qtde ? this.empresasEscolhidas : [],
      descricao: nome + this.teste.descricao + (qtde ? ` · ${qtde} ${qtde === 1 ? 'empresa' : 'empresas'}` : ' · todas as empresas'),
    });
    this.mostrar = false;
  }

  private identificar(): void {
    const digitos = this.cnpj.replace(/\D/g, '');
    if (digitos.length !== 11 && digitos.length !== 14) {
      return;
    }
    this.service.clientesPorCnpj([digitos]).subscribe((lista) => {
      if (lista.length && this.cnpj.replace(/\D/g, '') === digitos) {
        this.cliente = lista[0];
      }
    });
  }
}
